<template>
  <div class="home flex items-center flex-col">
    <div v-if="todo !== false && !this.deleting" class="home flex items-center flex-col w-full" >
        
        <div class="m-2 py-2 px-2 w-1/2 flex flex-row items-center bg-gradient-to-r from-purple-300 to-fuchsia-300 rounded-lg font-semibold text-purple-700 text-2xl border-2 border-purple-500">
            <input class="mr-2" type="checkbox" id="checkbox" :checked="isDone"  @click="done">
            <input v-model="todo.content" class= "bg-transparent w-full" @keyup="updateTodo()" :placeholder="text">
        </div>
        <div v-if="todo.category" class="cursor-default max-w-sm font-thin m-2 py-1 px-1  flex flex-row items-center bg-gradient-to-r from-blue-300 to-blue-200 rounded-lg text-blue-900 text-xl shadow-xl shadow-blue-200 border-2 border-blue-500 hover:bg-blue-500 hover:shadow-2xl transition-all duration-300 ring-offset-2 focus:ring-2 focus:ring-blue-400">
          <span >{{todo.category}}</span>
        </div>

        <select name="chooseCategory" id="chooseCategory" class="mt-10 cursor-pointer">
          <option value="none" selected disabled hidden>{{todo.category}}</option>
          <option v-for="category in categories" :key="category.id" :id="category.id" :text="category.title"> {{category.title}} </option>
        </select>
        <input type="submit" value="Change Category" @click="updateCategory()" class="max-w-sm font-thin m-2 py-1 px-1  flex flex-row items-center rounded-lg text-blue-900 text-sm shadow-lg shadow-blue-200 border-2 border-blue-500 hover:bg-blue-300 hover:shadow-2xl transition-all duration-300 ring-offset-2 focus:ring-2 focus:ring-blue-400 bg-blue-100 cursor-pointer">

        <button @click="doDelete" class="font-thin mt-7 py-1 px-1 flex flex-row items-center rounded-lg text-orange-100 text-sm shadow-lg shadow-red-200 border-2 border-red-500 hover:bg-red-600 hover:shadow-2xl transition-all duration-300 ring-offset-2 focus:ring-2 focus:ring-red-400 bg-red-400"> Delete ToDo </button>
        
    
    </div>
    <div v-else>
       LOADING
    </div>
  </div>
</template>

<script>
import { auth, db } from "@/firebaseConfig";


export default {
  name: 'TodoView',
  data: function() {
    return {
      id: false,
      text: '',
      todo: false,
      categories: false,
      deleting: false,
      isDone: false,
      chooseCategory: ""
    }
  },
  firestore: function() {
    return {
      todo: db.collection("todos").doc(this.$route.params.id),
      categories: db.collection('categories').where('user', '==', auth.currentUser.uid),
    }
  },
  beforeUpdate: function() {
    if (this.todo === null && !this.deleting) {
      this.$router.replace({name:'404'})
    }
    else if (this.todo === null && this.deleting) {
      this.$router.push({name:'todos'})

    }
  },
  
  beforeCreate: function() {
    auth.onAuthStateChanged((user) => {
      console.log("user state:", user);
      this.user = user
      if (!user) {        
        this.$router.push('/')
      }
      console.log(this.$route.params.id)
      db.collection('todos').doc(this.$route.params.id).get().then(doc => {
        if(doc.exists) {
          this.id = doc.id
          this.text = doc.data().content
          this.isDone = doc.data().doneBool
        }
      })
    });
  },
  methods: {
    updateCategory: function() {
      var e = document.getElementById("chooseCategory");
      var value = e.options[e.selectedIndex].value;
      this.chooseCategory= value;
      db.collection('todos').doc(this.id).update({
            category: this.chooseCategory
        });
      
  },
    updateTodo: function() {
        db.collection('todos').doc(this.id).update({
            content: this.todo.content
        });
    },
    doDelete: function() {
      this.deleting = true
      this.$firestoreRefs.todo.delete()
    },
    done() {
        db.collection('todos').doc(this.id).update({
            doneBool: !this.isDone
        });

    }
  }
}
</script>

<style scoped>

</style>